module.exports = __webpack_public_path__ + "static/xl-aa566eeccd198538450c8408c07e9d61.png";